









































import Vue from 'vue';
import { mapState } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import UserAPI from '@/services/UserAPI';

import Util from '@/util/Util';
import utilMixin from '@/mixin/Util';

import ResetPassword from '@/form/ResetPassword';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';

export default Vue.extend({
    name: 'ResetPassword',

    components: {
        Field,
        TInput
    },

    mixins: [utilMixin],

	created() {
        Util.updateHeaders((this as any).$text('ResetPassword'), (this as any).$text('hereResetPassword'), process.env.VUE_APP_DEFAULT_IMAGE);
    },

    data() {
        return {
            form: new ResetPassword(),
            error: {
                email: '',
                save: ''
                },
            reset: false,
            isLoading: false
        };
    },

    methods: {
        resetPassword() {
            if (Util.isEmpty(this.form.email)) {
                this.error.email = (this as any).$text('missingEmail');
            } else {
                this.error.email = '';
            }

            if (this.error.email === '') {

                const handleResponse = (response: AxiosResponse) => {
                        this.reset = true;
                    };

                const handleError = (error: AxiosError) => {
                        if (error.response) {
                            const status = error.response.status;
                        }
                    };

                this.error.save = '';
                this.isLoading = true;
                UserAPI
                    .resetPassword(this.form)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isLoading = false);
            }
        }
    }
});
